export default {
  namespaced: true,
  testing: {
    title: "Pruebas",
    penetration: {
      title: "Prueba de Penetración",
      participant: "Participante",
      required: "El campo es requerido",
      perticipantRequired: "Se requiere al menos un participante con nombre y perfil",
    },
    security_box: {
      title: "Prueba de Cajas de Seguridad",
      manager: "Responsable",
    },
    testResults: "Resultados Prueba",
    reopen: "Reasignar",
    reopenTest: "Reasignar prueba",
    result: "Resultado",
    type: "Tipo",
    maintenanceFormReference: "Referencia de formulario de mantenimiento",
    existingFiles: "Archivos existentes",
    date: "Fecha de registro",
    statusApprovedCanceledRejectedReagined: 'Aprobó/Rechazó/Cancelado'
  }
};
